document.addEventListener('DOMContentLoaded', function () {
  
  // DOM ELEMENTS
  const cartDrawer = document.getElementById('CartDrawer'); 
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay'); 
  const cartDrawerContent = document.getElementById('CartDrawerContent'); 
  const closeCartDrawerButton = document.getElementById('CloseCartDrawer'); 
  const cartCountElement = document.getElementById('CartCount'); 
  
  // PULLING DATA FROM THE THEME.LIQUID BRIDGE
  const cartType = window.ShopifyThemeConfig.cartType; 
  const productVariants = window.ShopifyThemeConfig.productVariants || [];
  let selectedOptions = {};
  let currentVariant = null;
  var currencySymbol = window.ShopifyThemeConfig.currencySymbol;

  function initializeSelections() 
  {
    const firstAvailableVariant = productVariants.find((variant) => variant.available);
    if (firstAvailableVariant) 
    {
     firstAvailableVariant.options.forEach((optionValue, index) => {
      const optionIndex = index + 1;
     const optionButtons = document.querySelectorAll(`.option-value[data-option="${optionIndex}"]`);
     optionButtons.forEach((button) => {
      if (button.getAttribute('data-value') === optionValue) 
      {
        button.classList.add('active');
      }
    });
    selectedOptions[`option${optionIndex}`] = optionValue;
    });
    updateOptionsAvailability();
    updateVariantAndPrice();
  }
}

function openCartDrawer() 
{
  if (cartType === 'drawer' && cartDrawer) 
  {
     cartDrawer.classList.add('open');
     cartDrawerOverlay.classList.add('fade-in-drawer');
     setTimeout(() => 
     {
       cartDrawerOverlay.classList.add('active'); 
     }, 200);
    document.body.style.overflow = 'hidden'; 
    updateCartDrawer();
  }
}

function closeCartDrawer() {
if (cartDrawer) {
  cartDrawer.classList.remove('open');
  cartDrawerOverlay.classList.remove('fade-in-drawer');
  cartDrawerOverlay.classList.remove('active'); 
  document.body.style.overflow = 'inherit'; 
}
}

if (cartDrawerOverlay) {
cartDrawerOverlay.addEventListener('click', function () {
  closeCartDrawer();
});
}

document.addEventListener('click', function (event) {
if (
  cartDrawer &&
  cartDrawer.classList.contains('open') &&
  !cartDrawer.contains(event.target) &&
  !event.target.closest('a[href="/cart"]')
) {
  closeCartDrawer();
}
});

if (closeCartDrawerButton) {
closeCartDrawerButton.addEventListener('click', function () {
  closeCartDrawer();
});
}

function updateCartCount(cartItemCount) {
if (cartCountElement) {
  cartCountElement.textContent = cartItemCount;
}
}

function updateCartDrawerTotal() {
const totalElement = document.querySelector('#CartDrawerTotal');
if (totalElement) {
    fetch('/cart?view=cart-drawer')
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch cart drawer content');
            }
            return response.text();
        })
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const updatedTotal = doc.querySelector('#CartDrawerTotal');
            if (updatedTotal) {
                totalElement.innerHTML = updatedTotal.innerHTML; 
            }
        })
        .catch(error => console.error('Error updating cart total:', error));
}
}


function updateCartDrawer() {
if (cartDrawerContent) {
  fetch('/cart?view=cart-drawer')
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.getElementById('CartDrawerContent');
      if (newContent) {
        cartDrawerContent.innerHTML = newContent.innerHTML;
        attachRemoveHandlers();
        attachQuantityHandlers();
      }
    })
    .catch((error) => console.error('Error updating cart drawer:', error));
}
}

function attachRemoveHandlers() {
document.querySelectorAll('.cart-drawer-item__remove-link').forEach((removeButton) => {
  removeButton.addEventListener('click', function (event) {
    event.preventDefault();
    const key = this.dataset.key;
    removeCartItem(key, this);
  });
});
}

function removeCartItem(key, removeButton) {
const cartItem = removeButton.closest('.cart-drawer-item');
if (cartItem) 
{
  cartItem.classList.add('fade-out-bck');
}

setTimeout(() => {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to remove item from cart');
        }
        return response.json();
    })
    .then(cart => {
        updateCartDrawer(); 
        updateCartDrawerTotal(); 
        updateCartCount(cart.item_count); 
    })
    .catch(error => console.error('Error removing cart item:', error));
}, 200);
}


function attachQuantityHandlers() {
document.querySelectorAll('.quantity-wrapper-drawer').forEach((wrapper) => {
  const key = wrapper.dataset.key;
  const inventoryQuantity = parseInt(wrapper.dataset.inventory);
  const trackQuantity = wrapper.dataset.trackQuantity === 'true';
  const allowOversell = wrapper.dataset.allowOversell === 'true';

  const minusButton = wrapper.querySelector('.cart-drawer__quantity-btn-minus');
  const plusButton = wrapper.querySelector('.cart-drawer__quantity-btn-plus');
  const quantityValue = wrapper.querySelector('.cart-drawer__quantity-value');

  function updateButtonStates() {
    const currentQuantity = parseInt(quantityValue.textContent);

    minusButton.classList.toggle('disabled', currentQuantity <= 1);
    minusButton.disabled = currentQuantity <= 1;

    if (trackQuantity && !allowOversell) {
      const isMaxQuantity = currentQuantity >= inventoryQuantity;
      plusButton.classList.toggle('disabled', isMaxQuantity);
      plusButton.disabled = isMaxQuantity;
    } else {
      plusButton.classList.remove('disabled');
      plusButton.disabled = false;
    }
  }

  function updateCartQuantity(quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error updating cart');
        }
        return response.json();
      })
      .then((cart) => {
        quantityValue.textContent = quantity;
        wrapper.dataset.quantity = quantity;
        updateButtonStates();
        updateCartDrawerTotal(cart);
        updateCartCount(cart.item_count);
      })
      .catch((error) => console.error('Error updating cart quantity:', error));
  }

  minusButton.addEventListener('click', () => {
    const currentQuantity = parseInt(quantityValue.textContent);
    if (currentQuantity > 1) {
      updateCartQuantity(currentQuantity - 1);
    }
  });

  plusButton.addEventListener('click', () => {
    const currentQuantity = parseInt(quantityValue.textContent);
    if (trackQuantity && !allowOversell && currentQuantity >= inventoryQuantity) {
      alert(`Maximum quantity for this product is ${inventoryQuantity}.`);
    } else {
      updateCartQuantity(currentQuantity + 1);
    }
  });

  updateButtonStates();
});
}

function attachVariantHandlers() {
const variantButtons = document.querySelectorAll('.option-value');
variantButtons.forEach((button) => {
  button.addEventListener('click', function () {
    const optionIndex = this.getAttribute('data-option');
    const value = this.getAttribute('data-value');
    if (!this.classList.contains('disabled')) {
      selectedOptions[`option${optionIndex}`] = value;
      updateActiveStates();
      updateOptionsAvailability();
      updateVariantAndPrice();
    }
  });
});
}

function updateActiveStates() {
document.querySelectorAll('.option-value').forEach((button) => {
  const optionIndex = button.getAttribute('data-option');
  if (selectedOptions[`option${optionIndex}`] === button.getAttribute('data-value')) {
    button.classList.add('active');
  } else {
    button.classList.remove('active');
  }
});
}

function updateOptionsAvailability() {
const allVariantsSoldOut = !productVariants.some((variant) => variant.available);
const addToCartButton = document.querySelector('.product-info__cart-btn');
if (allVariantsSoldOut) {
  addToCartButton.textContent = 'SOLD OUT';
  addToCartButton.disabled = true;
  document.querySelectorAll('.option-value').forEach((button) => {
    button.classList.add('disabled');
  });
} else {
  document.querySelectorAll('.option-value').forEach((button) => {
    const optionIndex = button.getAttribute('data-option');
    const value = button.getAttribute('data-value');
    const isAvailable = productVariants.some((variant) => {
      let matchesOtherSelectedOptions = true;
      Object.keys(selectedOptions).forEach((selectedOptionIndex) => {
        if (selectedOptionIndex !== `option${optionIndex}`) {
          matchesOtherSelectedOptions =
            matchesOtherSelectedOptions && variant[selectedOptionIndex] === selectedOptions[selectedOptionIndex];
        }
      });
      return matchesOtherSelectedOptions && variant.available && variant[`option${optionIndex}`] === value;
    });
    if (!isAvailable) {
      button.classList.add('disabled');
    } else {
      button.classList.remove('disabled');
    }
  });
}
}

function updateVariantAndPrice() 
{
const matchingVariant = findMatchingVariant();
const cartButton = document.querySelector('.product-info__cart-btn');

if (matchingVariant) {
    currentVariant = matchingVariant;
    document.getElementById('AddToCartForm').action = '/cart/add';
    document.querySelector('#AddToCartForm input[name="id"]').value = matchingVariant.id;

    const formattedPrice = formatPrice(matchingVariant.price);
    cartButton.disabled = false;
    cartButton.innerHTML = `Add to cart — ${formattedPrice}`;
} 
else 
{
    cartButton.disabled = true;
    cartButton.innerHTML = `Sold out`;
}
}

function findMatchingVariant() {
return productVariants.find((variant) =>
  Object.keys(selectedOptions).every((option) => variant[option] === selectedOptions[option]) && variant.available
);
}


function formatPrice(priceInCents) {
return currencySymbol + (priceInCents / 100).toFixed(2);
}



const addToCartForm = document.getElementById('AddToCartForm');
if (addToCartForm) 
{
addToCartForm.addEventListener('submit', function (event) 
{
event.preventDefault();
const variantId = document.querySelector('#AddToCartForm input[name="id"]').value;

fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: variantId, quantity: 1 }),
})
.then((response) => 
{
  if (!response.ok) 
  {
    throw new Error('Error adding to cart');
  }
  return response.json();
})
.then(() => {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      updateCartCount(cart.item_count); 
      if (cartType === 'drawer') {
        openCartDrawer();
        updateCartDrawer(); 
      } else if (cartType === 'page') {
        window.location.href = '/cart'; 
      }
    })
    .catch((error) => console.error('Error fetching cart:', error));
})
.catch((error) => console.error('Error adding to cart:', error));
});

}


document.querySelectorAll('a[href="/cart"]').forEach((cartLink) => {
cartLink.addEventListener('click', function (event) {
  if (cartType === 'drawer') {
    event.preventDefault();
    openCartDrawer();
    updateCartDrawer();
  }
});
});

initializeSelections();
attachVariantHandlers();
attachRemoveHandlers();
attachQuantityHandlers();
});